var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApolloQuery',{attrs:{"query":_vm.$options.query.customer,"variables":{ id: _vm.id }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var loading = ref_result.loading;
var error = ref_result.error;
var data = ref_result.data;
return [(loading)?_c('div',{staticClass:"loading apollo"},[_vm._v("\n      Loading...\n    ")]):(error)?_c('div',{staticClass:"error apollo"},[_vm._v("\n      An error occurred\n    ")]):(data)?_c('div',{staticClass:"result apollo"},[_vm._v("\n      "+_vm._s(data.getUser.name)+"\n    ")]):_c('div',{staticClass:"no-result apollo"},[_vm._v("\n      No result :(\n    ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }